import React from 'react';
import { StyleSheet, View } from 'react-native';
import { TextInput } from 'react-native-gesture-handler';
import { useDispatch, useSelector } from 'react-redux';
import { COLOR_GRAY, COLOR_GREEN, COLOR_WHITE } from '../../constants/color';
import { vmax, vw } from '../../constants/size';
import { getFontFamily } from '../../hooks/useFonts';
import { appSelector } from '../../store/redux/modules/app/appSelector';
import { appSlice } from '../../store/redux/modules/app/appSlice';

const baseFontSize = vmax / 14;
const padding = 10;

const styles = StyleSheet.create({
	container: {
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: COLOR_WHITE,
		borderColor: COLOR_GRAY,
		borderWidth: 2,
		fontFamily: getFontFamily('mplus'),
		paddingBottom: 20,
	},
	name: {
		fontSize: baseFontSize,
		fontWeight: 'bold',
		textAlign: 'center',
		// letterSpacing: baseFontSize / 4,
	},
	kana: {
		fontSize: baseFontSize / 3,
		textAlign: 'center',
	},
	destinations: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		backgroundColor: COLOR_GREEN,
		width: vw - padding * 2,
		paddingHorizontal: 30,
	},
	prev: {
		color: COLOR_WHITE,
		fontSize: baseFontSize / 3,
		textAlign: 'left',
	},
	next: {
		color: COLOR_WHITE,
		fontSize: baseFontSize / 3,
		textAlign: 'right',
	},
	alphabet: {
		fontSize: baseFontSize / 3,
		textAlign: 'center',
	},
});

const StationBoard: React.VFC = () => {
	const dispatch = useDispatch();
	const name = useSelector(appSelector.selectName);
	const kana = useSelector(appSelector.selectKana);
	const prev = useSelector(appSelector.selectPrev);
	const next = useSelector(appSelector.selectNext);
	const alphabet = useSelector(appSelector.selectAlphabet);
	return (
		<View style={styles.container}>
			<TextInput
				style={styles.name}
				value={name}
				onChangeText={(text) => {
					dispatch(appSlice.actions.saveName(text));
				}}
			/>
			<TextInput
				style={styles.kana}
				value={kana}
				onChangeText={(text) => {
					dispatch(appSlice.actions.saveKana(text));
				}}
			/>
			<View style={styles.destinations}>
				<TextInput
					style={styles.prev}
					value={prev}
					onChangeText={(text) => {
						dispatch(appSlice.actions.savePrev(text));
					}}
				/>
				<TextInput
					style={styles.next}
					value={next}
					onChangeText={(text) => {
						dispatch(appSlice.actions.saveNext(text));
					}}
				/>
			</View>
			<TextInput
				style={styles.alphabet}
				value={alphabet}
				onChangeText={(text) => {
					dispatch(appSlice.actions.saveAlphabet(text));
				}}
			/>
		</View>
	);
};

export default StationBoard;
